import { OrderStatus } from '@shared/model/order';

export const STATUS_MAP: Record<OrderStatus, string> = {
    completed: 'приобретено',
    on_payment: 'ожидает оплаты',
    order_reject: 'отклонено',
    order_forming: 'cоздано',
};
